module.exports = __webpack_public_path__ + "static/img/RU@2x.464d0af5.jpg";